import { useCallback } from "react";
import { useGrpcClient, usePropertyGrpcCall } from "../../lib/grpc";
import { transformTaxation, TYPE } from "./index";
import { TaxationAPIPromiseClient } from "../../gen/witbooking/backoffice/taxation/v1/taxation_api_grpc_web_pb";
import {
  FindTaxationsRequest,
  GetTaxationRequest,
  Taxation,
} from "../../gen/witbooking/backoffice/taxation/v1/taxation_api_pb";

export function useTaxation() {
  const client = useGrpcClient(TaxationAPIPromiseClient);
  const findTaxations = usePropertyGrpcCall(client, client.findTaxations);
  const getTaxation = usePropertyGrpcCall(client, client.getTaxation);

  return {
    onGetAllFee: useCallback(async () => {
      const request = new FindTaxationsRequest();
      const response = await findTaxations(request);
      const feeList = response.getFeesList().map(m => m.toObject());
      return feeList.map(obj => transformTaxation(obj, TYPE.FEE, true));
    }, [findTaxations]),

    onGetOneFee: useCallback(
      async (id: string) => {
        const request = new GetTaxationRequest();
        request.setId(id);
        const response = await getTaxation(request);
        const fee = response.getTaxation()?.getFee()?.toObject() as Taxation.AsObject;
        return transformTaxation(fee, TYPE.FEE, true);
      },
      [getTaxation]
    ),

    onGetAllTax: useCallback(async () => {
      const request = new FindTaxationsRequest();
      const response = await findTaxations(request);
      const taxList = response.getTaxesList().map(m => m.toObject());
      return taxList.map(obj => transformTaxation(obj, TYPE.TAX));
    }, [findTaxations]),

    onGetOneTax: useCallback(
      async id => {
        const request = new GetTaxationRequest();
        request.setId(id);
        const response = await getTaxation(request);
        const tax = response.getTaxation()?.getTax()?.toObject() as Taxation.AsObject;
        return transformTaxation(tax, TYPE.TAX);
      },
      [getTaxation]
    ),
  };
}
